/**
 * @generated SignedSource<<df0d920038b68699148d2090201e2007>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksHomeV2PickMorningStudioArticle$data = {
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"homeNativeArticleContentItemContent">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"homeRecommendedForYouSponsorArticleQueueItemsEdge">;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "hooksHomeV2PickMorningStudioArticle";
};
export type hooksHomeV2PickMorningStudioArticle$key = {
  readonly " $data"?: hooksHomeV2PickMorningStudioArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksHomeV2PickMorningStudioArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksHomeV2PickMorningStudioArticle"
};

(node as any).hash = "57769f89b3485847685ff2b27678f3f9";

export default node;
